<template>
  <div>
    <header-applis titre="Personnaliser l'offre à votre profil" sous-titre="S’organiser dans son activité professionnelle" index-progression-courante="3"
                   index-progression-secondaire="7"/>
    <choix-competence-repeater :competences="competences" :callback="sauvegarder"/>
    <skip-competences ecrant-suivant="travaillerequipe"/>
    <footer-applis ecran-precedent="organiseractivite" ecran-suivant="activitesquotidiennes" label-suivant="Je ne souhaite pas répondre aux questions"/>
  </div>
</template>

<script>
import HeaderApplis from '../../components/HeaderApplis';
import FooterApplis from '../../components/FooterApplis';
import ChoixCompetenceRepeater from '../../components/ChoixCompetenceRepeater';
import SkipCompetences from '../../components/SkipCompetences';

export default {
  name: 'utilisercodessociaux',
  components: {
    SkipCompetences,
    ChoixCompetenceRepeater,
    HeaderApplis,
    FooterApplis
  },
  data() {
    return {
      competences: [{
        niveau: 1,
        valeur: 'J\'identifie quelques règles liées à mon statut professionnel'
      }, {
        niveau: 2,
        valeur: 'Je respecte les règles et m’interroge sur les codes implicites'
      }, {
        niveau: 3,
        valeur: 'Je me situe et m’adapte à des cadres formels et/ou inconnus'
      }, {
        niveau: 4,
        valeur: 'J\'explique les codes sociaux d’un contexte professionnel'
      }]
    }
  },
  methods: {
    competencesTransversales() {
      return this.$store.getters.getCompetencesTansversales;
    },
    sauvegarder(competence) {
      let informations = {};
      Object.assign(informations, this.competencesTransversales());
      informations.utilisercodessociaux = competence;
      this.$store.commit('setCompetencesTransversales', informations);
      this.$router.push('travaillerequipe');
    }
  }
}
</script>